import { useState } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';
import { useLanguage } from '@/lib/LanguageContext';

export default function SolutionFAQ({ faqs = [] }) {
  const [openIndex, setOpenIndex] = useState(null);
  const { t } = useLanguage();

  const colors = [
    { border: 'border-[#0095fc]/30', badge: 'bg-[#0095fc]/10 text-[#0095fc]', chevron: 'text-[#0095fc]' },
    { border: 'border-[#0ff0b3]/40', badge: 'bg-[#0ff0b3]/15 text-[#0bbf93]', chevron: 'text-[#0bbf93]' },
    { border: 'border-[#7800f7]/25', badge: 'bg-[#7800f7]/10 text-[#7800f7]', chevron: 'text-[#7800f7]' },
  ];

  return (
    <div>
      <h2 className="font-heading font-bold text-2xl text-gray-900 mb-6 tracking-tight">{t('faq.sectionTitle')}</h2>
      <div className="max-w-3xl space-y-3">
        {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          const c = colors[i % 3];
          return (
            <div
              key={i}
              className={`rounded-2xl border transition-all duration-300 ${
                isOpen
                  ? `${c.border} bg-gray-50/50 shadow-md`
                  : `${c.border} bg-white hover:shadow-sm`
              }`}
            >
              <h3 className="m-0">
                <button
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center gap-3 p-4 text-left"
                >
                  <span className={`shrink-0 flex items-center gap-1.5 text-[10px] font-black uppercase tracking-widest rounded-full px-2.5 py-1 mt-0.5 ${c.badge}`}>
                    <HelpCircle size={11} />
                    FAQ
                  </span>
                  <span className="flex-1 font-heading font-semibold text-gray-900 text-sm lg:text-[15px] leading-snug">
                    {faq.q}
                  </span>
                  <ChevronDown
                    size={18}
                    className={`shrink-0 transition-transform duration-300 mt-0.5 ${isOpen ? `rotate-180 ${c.chevron}` : 'text-gray-400'}`}
                  />
                </button>
              </h3>
              <div className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
                <div className="overflow-hidden">
                  <p className="px-4 pb-4 text-gray-600 text-sm leading-relaxed font-light">
                    {faq.a}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}